/* global AGENCY_URL */

import BaseApi from 'common/api/base';

export default class AgencyApi extends BaseApi {
  constructor() {
    super();
    this.baseUrl = AGENCY_URL;
  }

  agency(agencyId) {
    const endpoint = `agencies/${agencyId}`;
    return this.fetch('GET', endpoint);
  }

  fetchAgencies() {
    return this.fetch('GET', 'agencies');
  }

  connectStripe(agencyId, params) {
    const endpoint = `agencies/${agencyId}/stripe/connect`;
    return this.fetch('POST', endpoint, {authorization_code: params.authorizationCode});
  }

  connectTokenTransit(agencyId, params) {
    const endpoint = `agencies/${agencyId}/tokentransit/connect`;
    return this.fetch('POST', endpoint, {token_transit_account_id: params.tokenTransitAccountId});
  }
}



// WEBPACK FOOTER //
// ./src/common/api/AgencyApi.js